import { useField } from "formik";
import React from "react";
import { Form, Label } from "semantic-ui-react";
import DatePicker from "react-datepicker";

interface Props {
  placeholder?: string;
  name: string;
  label?: string;
}

export default function MyDateInput(props: Props) {
  const [field, meta, helpers] = useField(props.name);

  return (
    <Form.Field error={meta.touched && !!meta.error}>
      {props.label && <label>{props.label}</label>}
      <DatePicker
        {...field}
        selected={(field.value && new Date(field.value)) || null}
        onChange={(date: Date | null) => helpers.setValue(date)}
        onBlur={() => helpers.setTouched(true)}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        dateFormat="dd/MM/yyyy h:mm aa"
        placeholderText={props.placeholder || "Select date and time"}
        popperClassName="custom-datepicker-popper"
        popperModifiers={[
          {
            name: 'preventOverflow',
            options: {
              boundary: 'viewport',
            },
          },
          {
            name: 'zIndexFix', // Custom modifier to handle z-index
            enabled: true,
            phase: 'write',
            fn: ({ state }) => {
              state.styles.popper.zIndex = '2000'; // Set a high z-index
            },
          },
        ]}
        autoComplete="off" // Disable browser autofill
      />
      {meta.touched && meta.error ? (
        <Label basic color="red">{meta.error}</Label>
      ) : null}
    </Form.Field>
  );
}